import React from 'react'
import { OutlinedInput, InputLabel, FormControl, Select, MenuItem } from '@mui/material/'

function SelectGender({ gender, setGender, disabled }) {
    return (
        <FormControl fullWidth>
            <InputLabel id="genderId">Select Gender*</InputLabel>
            <Select
                labelId="genderId"
                id="genderId"
                value={gender}
                label="Select Gender*"
                onChange={(e) => setGender(e.target.value)}
                required
                disabled={disabled}
            >



                <MenuItem key="1" value="F">Female</MenuItem>
                <MenuItem key="2" value="M">Male</MenuItem>


            </Select>
        </FormControl>
    )
}

export default SelectGender